__turbopack_context__.v({
  "content": "pXn0VG_content",
  "dark": "pXn0VG_dark",
  "icons": "pXn0VG_icons",
  "row": "pXn0VG_row",
  "seeAll": "pXn0VG_seeAll",
  "text": "pXn0VG_text",
});
